import React from "react";
// import {Link} from 'react-router-dom';
import styled from "styled-components";
import { Input } from "reactstrap";
import auth from "../../helpers/auth";

const Logo = styled.a`
  font-size: 1.25rem;
  color: #fff;
  font-weight: 500;
  letter-spacing: 1px;
`;

class Login extends React.Component {
  state = {
    error: false,
    username: "",
    password: "",
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const { username, password } = this.state;
    const { location } = this.props;

    auth.login(username, password, (loggedIn) => {
      if (!loggedIn) {
        return this.setState({
          error: true,
        });
      }

      if (location.state && location.state.nextPathname) {
        this.props.history.push(location.state.nextPathname);
      } else {
        this.props.history.push("/dashboard");
      }
    });
  };

  render() {
    const year = new Date().getFullYear();

    return (
      <div className="block-center mt-4 wd-xl">
        <div className="card card-flat">
          <div className="card-header text-center bg-dark">
            <Logo href="">MenDayz</Logo>
          </div>
          <div className="card-body">
            <p className="text-center py-2 mb-0">SIGN IN TO CONTINUE.</p>
            {this.state.error && (
              <p className="text-danger text-center">
                Wrong email or password.
              </p>
            )}
            <form
              className="mb-3"
              id="loginForm"
              noValidate
              onSubmit={this.handleSubmit}
            >
              <div className="form-group">
                <div className="input-group with-focus">
                  <Input
                    className="form-control border-right-0"
                    id="exampleInputEmail1"
                    type="text"
                    placeholder="Enter login"
                    autoComplete="off"
                    required
                    invalid={this.state.error}
                    value={this.state.username}
                    onChange={(e) =>
                      this.setState({ username: e.target.value })
                    }
                  />
                  <div className="input-group-append">
                    <span
                      style={{
                        borderColor: `${this.state.error && "#f05050"}`,
                      }}
                      className="input-group-text fa fa-envelope
                                                            text-muted bg-transparent border-left-0"
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="input-group with-focus">
                  <Input
                    className="form-control border-right-0"
                    id="exampleInputPassword1"
                    type="password"
                    invalid={this.state.error}
                    placeholder="Password"
                    required
                    onChange={(e) =>
                      this.setState({ password: e.target.value })
                    }
                  />
                  <div className="input-group-append">
                    <span
                      style={{
                        borderColor: `${this.state.error && "#f05050"}`,
                      }}
                      className="input-group-text fa fa-lock
                                                            text-muted bg-transparent border-left-0"
                    />
                  </div>
                </div>
              </div>
              <button className="btn btn-block btn-primary mt-3" type="submit">
                Login
              </button>
            </form>
          </div>
        </div>
        <div className="p-3 text-center">
          <span className="mr-2">&copy;</span>
          <span>{year}</span>
          <span className="mx-2">-</span>
          <span>JMR Technologies</span>
          <br />
        </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Pages/Login.js